import React, { useEffect, useState } from 'react';

import classnames from 'classnames';
import {
  FavoriteBorder,
  LocalOfferOutlined,
  Menu,
  NotificationsOutlined,
} from '@material-ui/icons';

import { trackPageView } from '../../lib/analytics';
import { useWishlist } from '../../context/WishlistContext';
import Sidebar from '../../components/Sidebar';
import WishlistSidebar from '../../components/WishlistSidebar';
import ItemShop from './components/ItemShop';
import WishlistView from './components/WishlistView';
import NotificationsView from './components/NotificationsView';

import './styles.scss';

function renderMainView(activeView, onOpenNotifications) {
  if (activeView === 'wishlist') {
    return <WishlistView />;
  }

  if (activeView === 'notifications') {
    return <NotificationsView />;
  }

  return (
    <>
      <ItemShop onOpenNotifications={onOpenNotifications} />

      <section id="about-section" className="homepage-promo">
        <div className="homepage-promo-content">
          <h2 className="homepage-promo-title">BUILD YOUR DREAM LOCKER.</h2>
          <p className="homepage-promo-text">Add what you love. We&apos;ll watch for it.</p>
        </div>
        <img
          className="homepage-promo-art"
          src="/assets/section-icons/llama-banner.png"
          alt=""
          aria-hidden
          draggable={false}
        />
      </section>

      <footer className="homepage-disclaimer">
        Fortnite Dashboard is not affiliated with Epic Games.
      </footer>
    </>
  );
}

export default function Home({ breakpoint }) {
  const { wishlist } = useWishlist();

  const [activeView, setActiveView] = useState('shop');
  const [showMobileNav, setShowMobileNav] = useState(false);

  const isMobile = breakpoint === 'mobile';
  const isShopView = activeView === 'shop';

  useEffect(() => {
    const pagePath = `/${activeView}`;
    const pageTitle = `Dashboard - ${activeView}`;

    trackPageView(pagePath, pageTitle);

    if (window.analytics && window.analytics.page) {
      window.analytics.page('dashboard', activeView);
    }
  }, [activeView]);

  function handleNavigate(view) {
    setActiveView(view);
    setShowMobileNav(false);
  }

  return (
    <div className="homepage">
      <div className="homepage-layout">
        {!isMobile && (
          <Sidebar
            activeView={activeView}
            onNavigate={handleNavigate}
          />
        )}

        <main className={classnames('homepage-main', { 'homepage-main--page': !isShopView })}>
          {renderMainView(activeView, () => handleNavigate('notifications'))}
        </main>

        {!isMobile && isShopView && (
          <WishlistSidebar
            onViewFull={() => handleNavigate('wishlist')}
            onAddMore={() => handleNavigate('shop')}
          />
        )}
      </div>

      {isMobile && (
        <>
          <header className="mobile-header">
            <button
              type="button"
              className="mobile-header-btn"
              onClick={() => setShowMobileNav(!showMobileNav)}
              aria-label="Menu"
            >
              <Menu />
            </button>
            <img
              src="/assets/logo.png"
              alt="Fortnite Dashboard"
              className="mobile-header-logo"
            />
            <div className="mobile-header-actions">
              <button
                type="button"
                className="mobile-header-btn"
                onClick={() => handleNavigate('notifications')}
                aria-label="Notifications"
              >
                <NotificationsOutlined />
              </button>
              <button
                type="button"
                className="mobile-header-btn wishlist"
                onClick={() => handleNavigate('wishlist')}
                aria-label="Wishlist"
              >
                <FavoriteBorder />
                {wishlist.length > 0 && (
                  <span className="mobile-header-badge">{wishlist.length}</span>
                )}
              </button>
            </div>
          </header>

          {showMobileNav && (
            <div className="mobile-nav-overlay" onClick={() => setShowMobileNav(false)} role="presentation">
              <div onClick={(e) => e.stopPropagation()} role="presentation">
                <Sidebar
                  activeView={activeView}
                  onNavigate={handleNavigate}
                />
              </div>
            </div>
          )}

          <nav className="mobile-bottom-nav">
            <button
              type="button"
              className={activeView === 'shop' ? 'active' : ''}
              onClick={() => handleNavigate('shop')}
            >
              <LocalOfferOutlined />
              SHOP
            </button>
            <button
              type="button"
              className={activeView === 'wishlist' ? 'active' : ''}
              onClick={() => handleNavigate('wishlist')}
            >
              <FavoriteBorder />
              WISHLIST
            </button>
            <button
              type="button"
              className={activeView === 'notifications' ? 'active' : ''}
              onClick={() => handleNavigate('notifications')}
            >
              <NotificationsOutlined />
              ALERTS
            </button>
          </nav>
        </>
      )}
    </div>
  );
}
